import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiArrowUpRight, FiMenu, FiX } from "react-icons/fi";
import logo from "../assets/code7s.svg";

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 18);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const navItems = [
    { name: "Services", href: "/services" },
    { name: "Products", href: "/products" },
    { name: "Work", href: "/portfolio" },
    { name: "About", href: "/about" },
  ];

  const isActive = (href) => {
    if (href === "/") return pathname === "/";
    return pathname.startsWith(href);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition duration-300 ${
        scrolled || open
          ? "border-neutral-950/10 bg-white/90 shadow-[0_12px_50px_rgba(17,17,17,0.08)] backdrop-blur-xl"
          : "border-neutral-950/10 bg-white/75 backdrop-blur-xl"
      }`}
    >
      <div
        className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-6 md:px-10 lg:px-16"
      >
        <Link to="/" className="flex items-center gap-3" aria-label="Code7s home">
          <img src={logo} alt="Code7s" className="h-8 w-auto" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-sm font-semibold transition ${
                isActive(item.href)
                  ? "text-neutral-950"
                  : "text-neutral-500 hover:text-neutral-950"
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <Link
          to="/contact"
          className="hidden items-center gap-2 rounded-full bg-neutral-950 px-4 py-2.5 text-sm font-semibold text-white shadow-[0_14px_40px_rgba(17,17,17,0.18)] transition hover:-translate-y-0.5 hover:bg-neutral-800 md:flex"
        >
          Start a build
          <FiArrowUpRight aria-hidden="true" />
        </Link>

        <button
          type="button"
          aria-label={open ? "Close menu" : "Open menu"}
          className="grid h-10 w-10 place-items-center rounded-full border border-neutral-950/10 bg-white text-xl text-neutral-950 md:hidden"
          onClick={() => setOpen((current) => !current)}
        >
          {open ? <FiX /> : <FiMenu />}
        </button>
      </div>

      <div
        className={`overflow-hidden border-t border-neutral-950/10 bg-white/95 backdrop-blur-xl transition-all duration-300 md:hidden ${
          open ? "max-h-[420px] opacity-100" : "max-h-0 border-transparent opacity-0"
        }`}
      >
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-4 sm:px-6">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`rounded-2xl px-4 py-3 text-base font-semibold ${
                isActive(item.href) ? "bg-neutral-950 text-white" : "text-neutral-700"
              }`}
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 flex items-center justify-between rounded-2xl bg-neutral-950 px-4 py-3 font-semibold text-white"
          >
            Start a build
            <FiArrowUpRight aria-hidden="true" />
          </Link>
        </div>
      </div>
    </header>
  );
}
